import React from 'react';
import {HiFire} from 'react-icons/hi';
import {TbMathFunctionOff} from 'react-icons/tb';
import {RiEnglishInput} from 'react-icons/ri';
import {TfiLayoutTab} from 'react-icons/tfi';
import {HiOutlineNewspaper} from 'react-icons/hi';
import {AiFillStar} from 'react-icons/ai';

import {AiOutlineHeart} from 'react-icons/ai';
import {RxVideo} from 'react-icons/rx';
import {AiOutlineStar} from 'react-icons/ai';
import logo from '../images/home page Picture.jpg';
import waec from '../images/waec.2..jpg';
import jamb from '../images/Official_JAMB_logo.png';
import neco from '../images/Neco_official_banner.jpg';
import sat from '../images/sat...png';
import general from '../images/general subject.jpg';
import science from '../images/science.jpg';
import art from '../images/art.jpg';
import commercial from '../images/commercial.jpg'
import '../styles/home.css';

const Home = () => {
  return (

     <div className='home'>
       
         <div className='first'>
            <div className='first_section'>
              <div className='first_section_title'>
                  <h3> Free Courses & Past Questions For All O-level Examinations</h3>
                </div>
                <div className='stext'>
                  <p>For the Assurance of Excellence Academic performance, this site provides free past questions for WAEC, JAMB, Post UTME & SAT Examinations. This site also provides exam focus and summary of every topic in every subject as recommended by the Unified Tertiary Matriculation Examination Board making the site one stop for Academic Excellence.</p>
                </div>
                <div className='first_btn'>
                  <a href='/pastQuestion'>
                   <button width='300px'>
                      past Question
                  </button> </a>

               <a href='/subject'>
                  <button>
                    syllabus
                  </button></a>
                </div>
            </div>
          <div className='first_img'>
            <img  classname='h_photo' src={logo} alt=''/>
          </div>
        </div>
    
       <div className='banner'>
           <div className='banner_text'>
             <h4>We made available over <span className='bt_c' color='#6255a5'> 200+ Past Questions across all Platforms </span></h4>
           </div>
           <div className='banner_logo'>
               <img src={waec} alt=''/>
             <img src={jamb} alt=''/>
             <img src={neco} alt=''/>
                <img src={sat} alt=''/>
           </div>
        </div>



        <div className='third_section'>
         <div className='third_section_first'>
             <h4> Keypoint & Exam Focus</h4>
         </div>
            <div className='third_section_second'>
                <h3> <span  className='fire' olor='#6255a5'> <HiFire/> </span> Explore our Trending course</h3>
            </div>
         <div className='third_section_third'>
                <p>The syllabus for every subject is made available for free to enable Academic excellence in all 0-level exams and A-level examinati0ns to get admission into University of choice</p>
         </div>

         <div className='third_section_cards'>
               <div className='ts_card'>
                    <span classname='ts_logo'> <TbMathFunctionOff/> </span>
                     <h3> Mathematics </h3>
                   <p>A comprehensive syllabus for Mathematics in preparation for Examinations</p>
                </div>
                <div className='ts_card'>
                <span > <RiEnglishInput/> </span>
                <h3> English </h3> 
                  <p>Syllabus recommended by UTME in Use of English for Board Examinations</p>
             </div>
             <div className='ts_card'>
                   <span classname='ts_logo'> <TfiLayoutTab/> </span>
                   <div> <h3>Jamb PQ </h3> </div>
                  <div><p>All past questions for all subject conducted by Joint Admissions And Matriculation Board</p></div>
              </div>
             <div className='ts_card'>
                  <span classname='ts_logo'> <HiOutlineNewspaper/> </span>
                   <h3>Waec PQ </h3>
                 <p>All past questions for all subject conducted by the west Africa Examination Council</p>
                </div>

            </div>

            <hr></hr>

        </div>

        <div className='forth_section'>
            <div className='subject'>
                <img src={general} alt=''/>
                <h3> General Subjects</h3>

                <div className='down'>
             
             <span>
              <i><RxVideo/></i>
                 <p>Subjects</p></span>
              <span>   <i> <AiOutlineHeart/></i>
                 <p>200+ Students</p> </span>
                 </div>
             <hr></hr>
            <div className='down'>
                <span><i className='yellow'> <AiFillStar/><AiFillStar/><AiFillStar/><AiFillStar/><AiOutlineStar/></i> <p>Reviews</p> </span>
                
                <button>Read</button>
                </div>
          </div>
            <div className='subject'>
              <img src={science} alt=''/>
              <h3> Science Subjects</h3>
              <div className='down'>
             
             <span>
              <i><RxVideo/></i>
                 <p>Subjects</p></span>
              <span>   <i> <AiOutlineHeart/></i>
                 <p>200+ Students</p> </span>
                 </div>
             <hr></hr>
            <div className='down'>
                <span><i className='yellow'> <AiFillStar/><AiFillStar/><AiFillStar/><AiFillStar/><AiOutlineStar/></i> <p>Reviews</p> </span>
                <button>Read</button>
                </div>
         </div>


            <div className='subject'>
                <img src={art} alt=''/>
                <h3> Art Subjects</h3>
                <div className='down'>
             
             <span>
              <i><RxVideo/></i>
                 <p>Subjects</p></span>
              <span>   <i> <AiOutlineHeart/></i>
                 <p>200+ Students</p> </span>
                 </div>
             <hr></hr>
            <div className='down'>
                <span><i className='yellow'> <AiFillStar/><AiFillStar/><AiFillStar/><AiFillStar/><AiOutlineStar/></i> <p>Reviews</p> </span>
                <button>Read</button>
                </div>
            </div>

            <div className='subject'>
             <img src={commercial} alt=''/>

             <h3> Commercial Subjects</h3>
             <div className='down'>
             
             <span>
              <i><RxVideo/></i>
                 <p>Subjects</p></span>
              <span>   <i> <AiOutlineHeart/></i>
                 <p>200+ Students</p> </span>
                 </div>
             <hr></hr>
            <div className='down'>
                <span><i className='yellow'> <AiFillStar/><AiFillStar/><AiFillStar/><AiFillStar/><AiOutlineStar/></i> <p>Reviews</p> </span>
                <button>Read</button>
                </div>
               
               
            </div>
     </div>


        <div className='fiveth_section'>
            <div className='pastq'>
             <img src={waec} alt=''/>
             <h3> Waec Past Question</h3>
             <div className='down'>
             
             <span>
              <i><RxVideo/></i>
                 <p>Subjects</p></span>
              <span>   <i> <AiOutlineHeart/></i>
                 <p>200+ Students</p> </span>
                 </div>
             <hr></hr>
            <div className='down'>
                <span><i className='yellow'> <AiFillStar/><AiFillStar/><AiFillStar/><AiFillStar/><AiOutlineStar/></i> <p>Reviews</p> </span>
                <a href='/waec'>
                <button>Read</button></a>
                </div>
         </div>

            <div className='pastq'>
                <img src={jamb} alt=''/>
              <h3> Jamb Past Question</h3>
              <div className='down'>
             
             <span>
              <i><RxVideo/></i>
                 <p>Subjects</p></span>
              <span>   <i> <AiOutlineHeart/></i>
                 <p>200+ Students</p> </span>
                 </div>
             <hr></hr>
            <div className='down'>
                <span><i className='yellow'> <AiFillStar/><AiFillStar/><AiFillStar/><AiFillStar/><AiOutlineStar/></i> <p>Reviews</p> </span>
                <a href='/jamb'>
                 <button>Read</button></a>
                </div>
            </div>


            <div className='pastq'>
                <img src={sat} alt=''/>
             <h3> Sat Past Question</h3>
             <div className='down'>
             
             <span>
              <i><RxVideo/></i>
                 <p>Subjects</p></span>
              <span>   <i> <AiOutlineHeart/></i>
                 <p>200+ Students</p> </span>
                 </div>
             <hr></hr>
            <div className='down'>
                <span><i className='yellow'> <AiFillStar/><AiFillStar/><AiFillStar/><AiFillStar/><AiOutlineStar/></i> <p>Reviews</p> </span>
                <button>Read</button>
                </div>
            </div>
     </div>



      <div className='sixth_section'>
         <div className='moree'>  <h3>Join Thousands of Students Around</h3></div>
             <h3>The Country and Start Studying Together </h3>
          <span><button>Join A Study Room</button> <button>Discord Server</button></span>

        </div>

     </div>



  )
}

export default Home